import React from "react";
import { Table } from "react-bootstrap";

/**
 * Presentational pieces of the responses page: the summary numbers, the filter query, and the
 * table (one column per question of the selected version, SPEC 19.5).
 */

export const ANONYMOUS = "anonymous";
export const IDENTITY_HEADERS = ["Employee no.", "Name", "Department", "Country", "Submitted (UTC)"];

// Keys = the query-string names the server validates and applies (server ResponseQuery.php:40-47,
// 84-95): the date range is date_from / date_to, never from / to.
export const EMPTY_FILTERS = { country_id: "", department_id: "", date_from: "", date_to: "", version: "" };

// Only the filters that are set travel to the server; `page` is added by the caller.
export const queryFromFilters = (filters) => {
  const query = {};
  Object.keys(filters || {}).forEach((key) => {
    if (filters[key] !== "" && filters[key] !== null && filters[key] !== undefined) query[key] = filters[key];
  });
  return query;
};

// Canonical answer -> cell text: text as is, rating the number, multi joined, yes_no Yes / No,
// date as is, unanswered empty (19.5).
export const answerText = (question, value) => {
  if (value === null || value === undefined || value === "") return "";
  if (Array.isArray(value)) return value.join("; ");
  if (question && question.qtype === "yes_no") return Number(value) === 1 ? "Yes" : "No";
  return String(value);
};

const identity = (value, anonymous) => (anonymous || value === null || value === undefined ? ANONYMOUS : String(value));

export const Metric = ({ label, value }) => (
  <div className="broadcast-metric">
    <span className="broadcast-metric-label">{label}</span>
    <span className="broadcast-metric-value">{value}</span>
  </div>
);

// The counts sit FLAT on the responses content (server BroadcastResponseController.php:117-121 merges
// ResponseQuery::summary — audience / completed / completion_rate — and `responses` = total into the
// top level; there is no `summary` block). `summary` here is that content.
export const Summary = ({ summary }) => {
  const s = summary || {};
  return (
    <div className="broadcast-metrics">
      <Metric label="Audience" value={Number(s.audience || 0)} />
      <Metric label="Completed" value={Number(s.completed || 0)} />
      <Metric label="Completion rate" value={Number(s.completion_rate || 0) + "%"} />
      <Metric label="Responses" value={Number(s.responses || 0)} />
    </div>
  );
};

export const ResponsesTable = ({ questions, rows, anonymous }) => {
  const ordered = (questions || []).slice().sort((a, b) => Number(a.position) - Number(b.position));
  return (
    <Table responsive hover size="sm" className="broadcast-table broadcast-responses-table">
      <thead>
        <tr>
          {IDENTITY_HEADERS.map((h) => <th key={h}>{h}</th>)}
          {ordered.map((q) => <th key={q.id}>{q.label}</th>)}
        </tr>
      </thead>
      <tbody>
        {(rows || []).map((row) => {
          const answers = row.answers || {};
          return (
            <tr key={row.id}>
              <td>{identity(row.emp_num, anonymous)}</td>
              <td>{identity(row.full_name, anonymous)}</td>
              <td>{row.department_name || ""}</td>
              <td>{row.country_name || ""}</td>
              <td className="broadcast-window">{row.submitted_at}</td>
              {ordered.map((q) => <td key={q.id}>{answerText(q, answers[String(q.id)])}</td>)}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
